/* eslint-disable */
// This is auto generated code, do not edit directly
// @ts-ignore
import * as Types from '../../../../core/graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SignOutMutationVariables = Types.Exact<{ [key: string]: never }>;

export type SignOutMutation = {
	__typename?: 'Mutation';
	signOut: { __typename?: 'SignOutResult'; success: boolean; message: string };
};

export const SignOutDocument = gql`
	mutation SignOut {
		signOut {
			... on SignOutResult {
				success
				message
			}
		}
	}
`;
export type SignOutMutationFn = Apollo.MutationFunction<
	SignOutMutation,
	SignOutMutationVariables
>;

/**
 * __useSignOutMutation__
 *
 * To run a mutation, you first call `useSignOutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignOutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signOutMutation, { data, loading, error }] = useSignOutMutation({
 *   variables: {
 *   },
 * });
 */
export function useSignOutMutation(
	baseOptions?: Apollo.MutationHookOptions<
		SignOutMutation,
		SignOutMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<SignOutMutation, SignOutMutationVariables>(
		SignOutDocument,
		options
	);
}
export type SignOutMutationHookResult = ReturnType<typeof useSignOutMutation>;
export type SignOutMutationResult = Apollo.MutationResult<SignOutMutation>;
export type SignOutMutationOptions = Apollo.BaseMutationOptions<
	SignOutMutation,
	SignOutMutationVariables
>;
